import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Utils } from '../shared/utils';

@Component({
  selector: 'app-validar-assinatura-upload',
  templateUrl: './validar-assinatura-upload.component.html',
  styleUrls: ['./validar-assinatura-upload.component.css'],
  providers: [Utils]
})
export class ValidarAssinaturaUploadComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;

  public titulo: string = 'Validar Assinatura';
  public arquivo: File = null;
  public nomeArquivo: string = '';
  public processando: boolean = false;
  public resultado: any = null;
  public erro: string = null;
  public dragOver: boolean = false;

  constructor(
    private http: Http,
    private utils: Utils
  ) { }

  ngOnInit() { }

  onFileSelected(event: any): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.selecionarArquivo(files[0]);
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;

    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      this.selecionarArquivo(files[0]);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;
  }

  selecionarArquivo(file: File): void {
    if (file.type !== 'application/pdf') {
      this.erro = 'Por favor, selecione um arquivo PDF.';
      this.utils.flashMessage(this.erro, 'warning');
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      this.erro = 'O arquivo excede o tamanho máximo de 10MB.';
      this.utils.flashMessage(this.erro, 'warning');
      return;
    }

    this.arquivo = file;
    this.nomeArquivo = file.name;
    this.erro = null;
    this.resultado = null;
  }

  abrirSeletor(): void {
    this.fileInput.nativeElement.click();
  }

  limpar(): void {
    this.arquivo = null;
    this.nomeArquivo = '';
    this.resultado = null;
    this.erro = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  validar(): void {
    if (!this.arquivo) {
      this.utils.flashMessage('Selecione um arquivo PDF primeiro.', 'warning');
      return;
    }

    this.processando = true;
    this.erro = null;
    this.resultado = null;

    const formData = new FormData();
    formData.append('arquivo', this.arquivo);

    this.http.post('/validar-certificado/upload', formData)
      .toPromise()
      .then(response => {
        const json = response.json();
        this.resultado = json.dados;
        this.processando = false;
        this.utils.flashMessage(json.msg || 'Certificado validado com sucesso.', 'success');
      })
      .catch(error => {
        this.processando = false;
        let msg = 'Erro ao validar o certificado.';
        if (error.status === 422 || error.status === 400 || error.status === 404) {
          try {
            msg = error.json().msg || msg;
          } catch (e) { }
        }
        this.erro = msg;
        this.utils.flashMessage(msg, 'danger');
      });
  }

  statusClasse(): string {
    if (!this.resultado) return '';
    return this.resultado.assinaturas_internas && this.resultado.assinaturas_internas.length > 0
      ? 'green darken-1'
      : 'amber darken-2';
  }

  statusIcone(): string {
    return 'check_circle';
  }

  formatarData(data: string): string {
    if (!data) return '-';
    const partes = data.split(/[- :]/);
    if (partes.length < 5) return data;
    return `${partes[2]}/${partes[1]}/${partes[0]} às ${partes[3]}:${partes[4]}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/validar-assinatura-upload/validar-assinatura-upload.component.ts